module.exports = __webpack_public_path__ + "static/media/Ben-profile.34c80fff.jpg";